import { useMissionsTranslation } from '../../../ui/hooks';
import { AlertsListSent } from '@juvare/alert-ui/ui/features/alerts/components/AlertsListSent';
import { showCustomDialog } from '@juvare/common-web-ui/DialogHelper';
import CampaignOutlinedIcon from '@mui/icons-material/CampaignOutlined';
import React from 'react';
import { VolunteerRecipientsModal } from './components/VolunteerRecipientsModal';
export const Messages = ({ missionId }) => {
    const { t } = useMissionsTranslation();
    const handleSendMessageButton = () => {
        showCustomDialog({
            content: (close) => React.createElement(VolunteerRecipientsModal, { onCloseModal: close, missionId: missionId }),
        });
    };
    const mainAction = {
        label: t('missions.messages.buttonLabel'),
        icon: React.createElement(CampaignOutlinedIcon, null),
        onClick: handleSendMessageButton,
    };
    return (React.createElement(AlertsListSent, { title: t('missions.messages.pageTitle'), mainAction: mainAction, staticFilterData: { searchData: [missionId] } }));
};
